export * from './testing'

export const DESKTOP = 'desktop' as const
export const MOBILE = 'mobile' as const
